import React from 'react';
import { SVG } from 'src/shared/design-system/Utilities/SVG';

export const BaseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG height={16} width={16} viewBox={'0 0 16 16'} {...props} />
);
